import { StyleSheet, css } from 'aphrodite'
import type React from 'react'
import type { Stop } from '../constants/stopsData'
import { DurationSelector } from './DurationSelector'

interface SelectedStopsProps {
  stops: Stop[]
  durations: { [key: string]: string }
  onDurationChange?: (stopId: string, value: string) => void
  onDeleteStop?: (stopId: string) => void
  disabled?: boolean
}

const styles = StyleSheet.create({
  description: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '125%',
    color: '#6B7280',
  },
  selectedStopsSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 0,
    gap: 16,
    marginTop: 8,
    marginBottom: 16,
  },
  selectedStopContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: 16,
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    border: '1px solid #E5E7EB',
  },
  stopInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  stopContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
  },
  label: {
    fontSize: '12px',
    fontWeight: 500,
    color: '#111928',
    lineHeight: '150%',
    fontFamily: 'Inter',
  },
  container: {
    width: '100%',
  },
  stopHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  deleteButton: {
    background: 'none',
    border: 'none',
    padding: '4px 8px',
    cursor: 'pointer',
    ':disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
})

const SelectedStops: React.FC<SelectedStopsProps> = ({
  stops,
  durations,
  onDurationChange,
  onDeleteStop,
  disabled = false,
}) => {
  if (stops.length === 0) return null

  return (
    <div className={css(styles.container)}>
      <h3 className={css(styles.description)}>DELAYS & STOPS</h3>
      <div className={css(styles.selectedStopsSection)}>
        {stops.map((stop) => (
          <div key={stop.id} className={css(styles.stopContainer)}>
            <div className={css(styles.stopHeader)}>
              <label className={css(styles.label)}>{stop.label}</label>
              <button
                onClick={() => onDeleteStop?.(stop.id)}
                className={css(styles.deleteButton)}
                disabled={disabled}
              >
                <i className="fa-solid fa-minus" style={{ color: '#DC2626' }} />
              </button>
            </div>
            <DurationSelector
              value={durations[stop.id] || stop.duration || ''}
              onChange={(value) => onDurationChange?.(stop.id, value)}
              disabled={disabled}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default SelectedStops
